export default function CalendarIcon({ label = '', color = '#666', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={18}
      fill="none"
      role="img"
      aria-label={label ? 'Calendar with ' + label : 'Calendar'}
      {...props}>
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11 1v3M5 1v3M13.444 2.292H2.556c-.86 0-1.556.66-1.556 1.476V14.1c0 .815.696 1.476 1.556 1.476h10.888c.86 0 1.556-.66 1.556-1.476V3.768c0-.815-.696-1.476-1.556-1.476Z"
      />
      {/* centered letter */}
      <text
        x="8"
        y="10.5"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="10"
        fontFamily="Roboto"
        fontWeight="600"
        fill={color}
        pointerEvents="none">
        {label}
      </text>
    </svg>
  );
}
